import React from 'react';

const PlayIconVector = ({ ...props }) => (
  <svg
    width="59"
    height="59"
    viewBox="0 0 59 59"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M29.5958 0.166016C13.3973 0.166016 0.267578 13.2955 0.267578 29.4936C0.267578 45.6918 13.3973 58.8213 29.5958 58.8213C45.7942 58.8213 58.924 45.6918 58.924 29.4936C58.924 13.2955 45.7942 0.166016 29.5958 0.166016ZM21.106 15.6016L44.2599 29.4936L21.106 43.3857V15.6016Z"
      fill="white"
    />
  </svg>
);

export default PlayIconVector;
